import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { NewVessel, NewVesselMode } from './model';
import { EditNewVesselOverridesView } from 'portcall/editnewvesseloverrides/view';
import { ExternalVesselSearchView } from 'portcall/externalvesselsearch/view';

export const NewVesselView = SuperCritical(({model} : { model : NewVessel }) =>
    model.Mode() === NewVesselMode.ExternalVesselService 
        ? <ExternalVesselSearchView model={model.VesselSearch} />
        : <EditNewVesselOverridesView model={model.EditOverrides} />
);


// WEBPACK FOOTER //
// ./apps/portcall/newvessel/view.tsx